function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.88,234.79c-5.1,43.2-24.83,93.42-64.22,116.5-59.52,34.87-54.54,88.5-170.72,111.81A238.8,238.8,0,0,1,191.43,468a198,198,0,0,1-25.28-2.06C92.31,455.12,42.62,403.8,24.39,341.84.4,260.36,48.3,207,80.06,174.88s55-132.29,169-156.11a231.93,231.93,0,0,1,52.94-5c40.58,1,84.83,14.32,115.45,42.13q3.45,3.14,6.71,6.49C466.75,106,484.84,175.89,477.88,234.79Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.88,234.79c-5.1,43.2-24.83,93.42-64.22,116.5-59.52,34.87-54.54,88.5-170.72,111.81A238.8,238.8,0,0,1,191.43,468a198,198,0,0,1-25.28-2.06C92.31,455.12,42.62,403.8,24.39,341.84.4,260.36,48.3,207,80.06,174.88s55-132.29,169-156.11a231.93,231.93,0,0,1,52.94-5c40.58,1,84.83,14.32,115.45,42.13q3.45,3.14,6.71,6.49C466.75,106,484.84,175.89,477.88,234.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.47,462.5H345.29a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H484.47a.5.5,0,0,1,.5.5A.5.5,0,0,1,484.47,462.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.17,462.5H24.81a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H336.17a.5.5,0,0,1,.5.5A.5.5,0,0,1,336.17,462.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,255.62s-3.43,9.44-10.72,10.72-20.16-12.86-12-20.15S29.55,250.48,33,255.62Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.33,266.92c-4.36,0-10.24-4.38-12.88-9.82-2.15-4.41-1.61-8.53,1.47-11.29a9.16,9.16,0,0,1,7.54-2.38c6.41.81,13,7.57,15.94,11.91a.48.48,0,0,1,.05.45c-.14.4-3.61,9.72-11.1,11A6.8,6.8,0,0,1,21.33,266.92Zm-5.15-22.58a8.19,8.19,0,0,0-5.59,2.22c-3.73,3.34-2.38,7.76-1.24,10.11,2.63,5.42,8.86,9.88,12.82,9.18,6.3-1.11,9.67-8.73,10.25-10.17-2.86-4.19-9.11-10.5-15.09-11.26A9,9,0,0,0,16.18,244.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.13,209.3s-10.72,26.16-6.43,39,30.88,22.3,38.6,5.58-9.44-40.32-15.87-45.47S46.28,205,44.13,209.3Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.45,263.39c-.44,0-.89,0-1.35,0-10.06-.55-20.33-7.22-22.87-14.86-4.3-12.89,6-38.3,6.44-39.38l0,0a8.14,8.14,0,0,1,5.71-4,13.62,13.62,0,0,1,11.34,3c6.57,5.25,23.85,29.09,16,46.07C74,260.13,68.57,263.39,61.45,263.39ZM44.59,209.51c-.32.79-10.55,26.25-6.42,38.66,2.43,7.29,12.29,13.65,22,14.19,4.26.23,12-.58,15.69-8.66,7.6-16.49-9.32-39.73-15.73-44.86A12.62,12.62,0,0,0,49.62,206,7.18,7.18,0,0,0,44.59,209.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.75,220.45s-18.44,16.73-20.59,33.46,10.3,22.73,23.16,20.58,19.3-34.74,15.45-49.75S106.75,220.45,106.75,220.45Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.37,275.42c-5.69,0-10.64-1.73-14-5-4-3.82-5.57-9.55-4.67-16.59,2.14-16.71,20.56-33.59,20.75-33.76l0,0c.29-.22,7.14-5.34,12.8-3.37,2.89,1,4.91,3.68,6,7.93,2.78,10.82.29,32.18-7.08,43.51-2.61,4-5.56,6.32-8.76,6.86A31.67,31.67,0,0,1,104.37,275.42Zm2.7-54.58c-.65.6-18.34,17-20.41,33.13-.86,6.71.65,12.15,4.38,15.74,4.12,4,10.75,5.53,18.2,4.29,2.92-.49,5.64-2.64,8.09-6.41,7.24-11.13,9.68-32.1,7-42.72-1-3.91-2.81-6.34-5.36-7.23C113.9,215.89,107.45,220.56,107.07,220.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.18,313.09S89.6,314,88.74,323.82s9,12,18.87,3.43S118.76,313.52,110.18,313.09Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87,333.12a8.35,8.35,0,0,1-3.82-.86c-2.81-1.43-4.16-4.45-3.81-8.49.89-10.18,21.06-11.14,21.92-11.18h0c3.41.17,5.44,1.11,6,2.77.89,2.58-1.89,6.71-8.28,12.26C103.82,331.2,99.5,333.12,95.87,333.12Zm14.31-19.53c-.77,0-20.15,1.09-20.94,10.27-.32,3.61.84,6.27,3.27,7.51,3.68,1.87,9.47.11,14.77-4.5,7.94-6.9,8.42-10,8-11.18C114.74,314.15,112.22,313.7,110.18,313.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.29,326.62l-.42-.91c.67-.3,16.37-7.46,23.65-8.75l.18,1C105.54,319.21,89.45,326.55,89.29,326.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,377.64s-15.12-14-22.72-7.65-2.17,14.85,10.87,15.8S120.52,384,114.77,377.64Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,386.48c-1.4,0-2.94-.07-4.62-.19-7.52-.55-13.07-3.61-14.48-8-1-3,.21-6.09,3.33-8.69,7.85-6.56,22.75,7.08,23.38,7.66l0,0c2.29,2.54,3.06,4.63,2.28,6.21C116.46,385.49,113.13,386.48,107.5,386.48ZM96.89,368.84a6.86,6.86,0,0,0-4.52,1.53c-2.78,2.33-3.85,5-3,7.62,1.27,3.93,6.61,6.79,13.61,7.3,10.48.77,13-1.05,13.56-2.21.72-1.46-.74-3.57-2.1-5.09C114,377.57,104.28,368.84,96.89,368.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,382.84c-5.94-4.18-22.49-10.42-22.65-10.48l.35-.94c.68.26,16.83,6.35,22.88,10.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,373.52S55.85,354.23,66.33,363s3,20.48-15,21.79S27.09,382.32,35,373.52Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,385.51c-7.65,0-12.17-1.33-13.46-4-1-2.1,0-4.92,3.1-8.36l0,0c.86-.8,21.29-19.49,32-10.56,4.23,3.53,5.84,7.71,4.53,11.77-1.92,6-9.51,10.15-19.8,10.9C49.05,385.42,46.92,385.51,45,385.51Zm-9.63-11.64c-2.78,3.1-3.77,5.53-2.94,7.23,1,2,5,4.17,18.89,3.16,9.72-.71,17.15-4.71,18.92-10.2,1.17-3.65-.33-7.45-4.22-10.7C56.11,355.09,36,373.25,35.36,373.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,380.54l-.58-.82c8.32-5.86,30.56-14.24,31.5-14.6l.35.94C68.24,366.15,45.41,374.75,37.2,380.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,333.68S57,344,49.28,347.83s-21.44-4.29-14.15-16.72S55.28,328.53,59.14,333.68Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,349.29a13.32,13.32,0,0,1-9.5-4.09c-3.59-3.84-3.87-9.06-.77-14.35,2.31-3.94,5.35-6,9-6.25,6.43-.36,13.1,5.19,15.79,8.78a.48.48,0,0,1,.09.4c-.09.43-2.28,10.58-10.13,14.5A10.13,10.13,0,0,1,45,349.29Zm-.63-23.71-.53,0c-3.35.19-6.12,2.13-8.25,5.76-2.86,4.87-2.63,9.67.64,13.15s9,4.82,12.86,2.88c6.79-3.4,9.18-12.1,9.54-13.59C55.86,330.25,49.83,325.58,44.34,325.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,301.51s-3.86-8.57-18.87-3-21,14.15-11.58,17.16S41.13,301.51,41.13,301.51Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16,316.52a8.53,8.53,0,0,1-2.63-.38c-4-1.26-4.84-3.32-4.88-4.82C5.55,307,12,301.79,22.09,298c15.27-5.67,19.46,3.18,19.5,3.27a.51.51,0,0,1-.14.59C40.65,302.55,23.41,316.52,13.16,316.52Zm18.29-19.41a26.14,26.14,0,0,0-9,1.87c-9.38,3.48-15.87,8.55-15.78,12.31,0,2.14,2.3,3.3,4.18,3.9,8.46,2.69,27-11.69,29.66-13.81C39.86,300.31,37.45,297.11,31.45,297.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.08,310.53l-.64-.76c8.61-7.32,24.11-9.07,24.76-9.14l.11,1C38.15,301.64,22.46,303.41,14.08,310.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,198.58s2.57,6,7.72,4.72,6.43-9,14.58-6.86,15,11.58,15,7.29S111,188.29,99.46,188.29,84.45,193,84,198.58Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,205.33c-.93,0-2.24-1-4.22-2.51-2.68-2.06-6.36-4.87-10.28-5.9-4.77-1.25-7,1-9.31,3.36-1.44,1.46-2.93,3-5,3.5-5.49,1.38-8.27-4.94-8.3-5a.67.67,0,0,1,0-.24c.56-7.23,5.77-10.75,15.94-10.75,12.21,0,22.37,11.57,22.37,15.94,0,.29,0,1.17-.66,1.49A.93.93,0,0,1,120.7,205.33Zm-17-9.77a10.86,10.86,0,0,1,2.79.39c4.12,1.09,7.89,4,10.64,6.07,1.36,1,3.24,2.47,3.64,2.31h0s.1-.11.1-.6c0-4.19-10.16-14.94-21.37-14.94-9.48,0-14.37,3.17-14.93,9.7.37.8,2.73,5.41,7.09,4.32,1.82-.45,3.15-1.8,4.56-3.23C98.05,197.67,100.13,195.56,103.66,195.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,324.87a57,57,0,0,0-1.91-6.22C59.37,298.79,42,301.86,41.23,302L41,301c.19,0,19-3.38,26.72,17.28a58.34,58.34,0,0,1,1.94,6.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,281.65s3.86-8.58,18.87-3,21,14.16,11.58,17.16S118.21,281.65,118.21,281.65Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,296.65c-10.26,0-27.5-14-28.29-14.62a.49.49,0,0,1-.14-.59c0-.09,4.23-8.93,19.5-3.26,10.09,3.74,16.54,8.95,16.43,13.27,0,1.51-.91,3.56-4.87,4.83A8.89,8.89,0,0,1,146.18,296.65Zm-27.33-15.13c2.68,2.13,21.21,16.49,29.65,13.8,1.88-.59,4.13-1.76,4.18-3.9.09-3.76-6.4-8.82-15.78-12.31C124.22,274.4,119.76,280.05,118.85,281.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,290.69c-7.06-8.72-22.22-8-22.37-8l0-1c.64,0,15.81-.77,23.19,8.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,283.85l-.4-.92a24,24,0,0,1,13.08-1.77l-.19,1A23.48,23.48,0,0,0,105.62,283.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,266.61c-8.82-9-17.63-10.48-17.72-10.49s-13-3.38-17.94,1.1l-.68-.73c5.3-4.86,18.28-1.5,18.83-1.35.32.05,9.16,1.52,18.22,10.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.91,
    y: 215.12,
    width: 1,
    height: 3.67,
    transform: "translate(-46.14 16.69) rotate(-12.62)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2,408.37l-1,0c0-.73,1.9-74.08,0-96.23s-10.78-48.32-10.87-48.59l-9.15-40.86,1-.22,9.14,40.81c.08.21,9,26.54,10.91,48.77S74.22,407.63,74.2,408.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.69,
    y: 232.34,
    width: 3.91,
    height: 1,
    transform: "translate(-145.99 236.46) rotate(-64.99)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.68,408.28h-1c0-.67.68-67.62,3.21-86.66s12.74-49.14,12.84-49.44l15.76-33.76.91.43L94.66,272.55c-.08.25-10.25,30.24-12.78,49.2S78.69,407.61,78.68,408.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,408.4l-1-.06c2.54-43.09,7-81.84,7-82.23l1,.11C89.53,326.61,85.06,365.33,82.53,408.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.79,408.29l-1,0c0-.62,1.25-61.62-1.26-69.78-.88-2.87-2.09-4.6-3.49-5a3.05,3.05,0,0,0-2.57.59l-.12.1-.15,0c-.11,0-11.67,1.45-15.79,8l-.85-.53c4.17-6.68,15-8.3,16.39-8.49a4,4,0,0,1,3.36-.69c1.77.52,3.17,2.43,4.18,5.69C69,346.51,67.84,405.77,67.79,408.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,408.37l-1-.05c0-.6,3.06-60.17-.25-78.68l1-.18C74.05,348.09,71,407.77,71,408.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,408.37c0-3.64-.79-89.58,6.85-109.94C93.8,292.5,97.15,288,101.51,285l.56.82c-4.19,2.87-7.4,7.24-9.55,13C85,319,85.73,407.47,85.73,408.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.76,408.34l-1-.13c1.8-13.24-1.85-90.07-12.16-119.69A60.48,60.48,0,0,0,52.83,269l.76-.65a61.7,61.7,0,0,1,11,19.81C74.9,317.93,78.57,395.05,76.76,408.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.68,408.28h-1c0-.74.45-75.2,1.07-112h1C79.13,333.08,78.69,407.53,78.68,408.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,291.67h-1c.51-29.67,1-50.41,1.42-61.64.78-20.24,1.92-31,3.4-31.87.59-1.43,3.86-7.47,16.1-6.69l-.07,1c-12.73-.84-15.09,6-15.18,6.27l-.25.75-.24-.23c-.51,1.11-1.82,6.3-2.76,30.81C80.82,241.28,80.34,262,79.83,291.67ZM83.68,199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.92,319.76s-10.73-9.56-6.44-14.26,30.88-8.15,38.6-2-9.43,14.73-15.87,16.61S65.06,321.33,62.92,319.76Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,321.73c-3.62,0-6.74-.6-8.06-1.57l0,0c-.3-.26-7.34-6.6-7.6-11.66a4.38,4.38,0,0,1,1.13-3.31c4.5-4.92,31.53-8.23,39.28-2.09,1.72,1.35,2.41,2.93,2.07,4.68-1.11,5.67-13.23,11.38-18.11,12.8A31.56,31.56,0,0,1,70.68,321.73Zm-7.45-2.36c2,1.39,9.43,2.1,15.84.22,5.58-1.63,16.46-7.2,17.41-12,.27-1.37-.29-2.58-1.71-3.7-7.35-5.82-33.8-2.53-37.92,2a3.38,3.38,0,0,0-.87,2.59C56.21,312.94,62.83,319,63.23,319.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.08,314.79h-1a19.69,19.69,0,0,1,.24-2.94l1,.16A18.8,18.8,0,0,0,73.08,314.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.23,308l-1-.28a49.89,49.89,0,0,1,2.79-7.19L77,301A49.27,49.27,0,0,0,74.23,308Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.92,382.28S52.19,372.72,56.48,368s30.88-8.15,38.6-2-9.43,14.73-15.87,16.61S65.06,383.84,62.92,382.28Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,384.24c-3.62,0-6.74-.59-8.06-1.56l0,0c-.3-.27-7.34-6.6-7.6-11.66a4.38,4.38,0,0,1,1.13-3.31c4.5-4.93,31.53-8.24,39.28-2.1,1.72,1.36,2.41,2.93,2.07,4.68-1.11,5.68-13.23,11.39-18.11,12.81A31.54,31.54,0,0,1,70.68,384.24Zm-7.45-2.35c2,1.39,9.43,2.1,15.84.22,5.58-1.63,16.46-7.2,17.41-12,.27-1.37-.29-2.58-1.71-3.7-7.35-5.82-33.8-2.53-37.92,2a3.37,3.37,0,0,0-.87,2.59C56.21,375.46,62.83,381.53,63.23,381.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.08,377.3h-1c0-6.21,3.82-13.91,4-14.24l.89.45C76.91,363.59,73.08,371.33,73.08,377.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9,355.84s-7.28-6.49-4.37-9.69,21-5.53,26.21-1.38-6.41,10-10.78,11.28S72.35,356.9,70.9,355.84Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15,357.34c-2.48,0-4.61-.42-5.55-1.1l0,0c-.21-.18-5-4.53-5.22-8a3.1,3.1,0,0,1,.81-2.36c3.16-3.47,21.41-5.78,26.89-1.44a3.31,3.31,0,0,1,1.46,3.33c-.77,3.92-9.07,7.84-12.41,8.82A21.54,21.54,0,0,1,76.15,357.34Zm-4.94-1.89c1.31.92,6.31,1.38,10.61.12,3.65-1.07,11.09-4.87,11.71-8.05a2.35,2.35,0,0,0-1.1-2.36c-5-3.92-22.76-1.71-25.53,1.33a2.1,2.1,0,0,0-.55,1.64C66.5,351.11,70.89,355.15,71.21,355.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,352.46H77c0-4.26,2.61-9.52,2.72-9.74l.89.45C80.55,343.22,78,348.44,78,352.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.83,
    y: 397.64,
    width: 29.02,
    height: 64.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.85,462.5h-29a.5.5,0,0,1-.5-.5V397.64a.5.5,0,0,1,.5-.5h29a.5.5,0,0,1,.5.5V462A.5.5,0,0,1,89.85,462.5Zm-28.52-1h28V398.14h-28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-2--inject-103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.37,
    y: 279.97,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,368.22H273.74a4.87,4.87,0,0,1-4.87-4.87v-79a4.87,4.87,0,0,1,4.87-4.87h91.08a4.88,4.88,0,0,1,4.87,4.87v79A4.88,4.88,0,0,1,364.82,368.22Zm-91.08-87.75a3.88,3.88,0,0,0-3.87,3.87v79a3.87,3.87,0,0,0,3.87,3.87h91.08a3.87,3.87,0,0,0,3.87-3.87v-79a3.88,3.88,0,0,0-3.87-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 275.22,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,363.47H270.57a4.88,4.88,0,0,1-4.87-4.87v-79a4.88,4.88,0,0,1,4.87-4.87h91.08a4.87,4.87,0,0,1,4.87,4.87v79A4.87,4.87,0,0,1,361.65,363.47Zm-91.08-87.75a3.88,3.88,0,0,0-3.87,3.87v79a3.87,3.87,0,0,0,3.87,3.87h91.08a3.87,3.87,0,0,0,3.87-3.87v-79a3.88,3.88,0,0,0-3.87-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,286.31v-6.72a4.37,4.37,0,0,0-4.37-4.37H270.57a4.37,4.37,0,0,0-4.37,4.37v6.72Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,286.81H266.2a.5.5,0,0,1-.5-.5v-6.72a4.88,4.88,0,0,1,4.87-4.87h91.08a4.87,4.87,0,0,1,4.87,4.87v6.72A.5.5,0,0,1,366,286.81Zm-99.32-1h98.82v-6.22a3.88,3.88,0,0,0-3.87-3.87H270.57a3.88,3.88,0,0,0-3.87,3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.69,
    cy: 281.05,
    r: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,284.22a3.17,3.17,0,1,1,3.17-3.17A3.17,3.17,0,0,1,339.69,284.22Zm0-5.34a2.17,2.17,0,1,0,2.17,2.17A2.17,2.17,0,0,0,339.69,278.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.83,281.05a2.68,2.68,0,1,0-2.67,2.67A2.67,2.67,0,0,0,350.83,281.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,284.22a3.17,3.17,0,1,1,3.17-3.17A3.18,3.18,0,0,1,348.16,284.22Zm0-5.34a2.17,2.17,0,1,0,2.17,2.17A2.18,2.18,0,0,0,348.16,278.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.62,
    cy: 281.05,
    r: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,284.22a3.17,3.17,0,1,1,3.17-3.17A3.17,3.17,0,0,1,356.62,284.22Zm0-5.34a2.17,2.17,0,1,0,2.17,2.17A2.17,2.17,0,0,0,356.62,278.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,324.37V294.62a2.79,2.79,0,0,1,2.79-2.79h73.88a2.79,2.79,0,0,1,2.79,2.79V312a2.79,2.79,0,0,1-2.79,2.78H283.08Zm2.79-31.54a1.79,1.79,0,0,0-1.79,1.79V321l4.56-7.14h71.11a1.79,1.79,0,0,0,1.79-1.78V294.62a1.79,1.79,0,0,0-1.79-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.44,359.43l-6.1-9.56H279.77a2.79,2.79,0,0,1-2.79-2.79v-17.4a2.79,2.79,0,0,1,2.79-2.79h73.88a2.79,2.79,0,0,1,2.79,2.79Zm-76.67-31.54a1.79,1.79,0,0,0-1.79,1.79v17.4a1.79,1.79,0,0,0,1.79,1.79h71.11l4.56,7.14V329.68a1.79,1.79,0,0,0-1.79-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.97,
    cy: 303.18,
    r: 6.68,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,310.36a7.18,7.18,0,1,1,7.18-7.18A7.19,7.19,0,0,1,291,310.36ZM291,297a6.18,6.18,0,1,0,6.18,6.17A6.19,6.19,0,0,0,291,297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.97,
    cy: 301.24,
    r: 2.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,304.52a3.29,3.29,0,1,1,3.28-3.28A3.28,3.28,0,0,1,291,304.52Zm0-5.57a2.29,2.29,0,1,0,2.28,2.29A2.29,2.29,0,0,0,291,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,309.86a6.63,6.63,0,0,0,3.9-1.26,3.9,3.9,0,0,0-7.8,0A6.65,6.65,0,0,0,291,309.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,310.36a7.11,7.11,0,0,1-4.19-1.36.51.51,0,0,1-.21-.41,4.4,4.4,0,0,1,8.8,0,.47.47,0,0,1-.2.41A7.16,7.16,0,0,1,291,310.36Zm-3.39-2a6.22,6.22,0,0,0,6.78,0,3.4,3.4,0,0,0-6.78,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.38,
    y: 297.12,
    width: 22.69,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.86,
    y: 303.58,
    width: 46.81,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.86,
    y: 307.68,
    width: 46.81,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.97,
    cy: 338.96,
    r: 6.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,346.14a7.18,7.18,0,1,1,7.18-7.18A7.19,7.19,0,0,1,291,346.14Zm0-13.36a6.18,6.18,0,1,0,6.18,6.18A6.19,6.19,0,0,0,291,332.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.97,
    cy: 337.01,
    r: 2.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,340.29a3.28,3.28,0,1,1,3.28-3.28A3.28,3.28,0,0,1,291,340.29Zm0-5.56a2.28,2.28,0,1,0,2.28,2.28A2.28,2.28,0,0,0,291,334.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,345.64a6.64,6.64,0,0,0,3.9-1.27,3.9,3.9,0,0,0-7.8,0A6.66,6.66,0,0,0,291,345.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,346.14a7.11,7.11,0,0,1-4.19-1.36.52.52,0,0,1-.21-.41,4.4,4.4,0,0,1,8.8,0,.48.48,0,0,1-.2.41A7.16,7.16,0,0,1,291,346.14Zm-3.39-2a6.22,6.22,0,0,0,6.78,0,3.4,3.4,0,0,0-6.78,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.38,
    y: 332.9,
    width: 22.69,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.86,
    y: 339.36,
    width: 46.81,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.86,
    y: 343.46,
    width: 46.81,
    height: 1,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-1--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.14,229H250.42a2.06,2.06,0,0,1,2.06,2.06v68.49A3.45,3.45,0,0,1,249,303H124.53a3.45,3.45,0,0,1-3.45-3.45V231.1A2.06,2.06,0,0,1,123.14,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,303.54H124.53a4,4,0,0,1-4-4V231.1a2.56,2.56,0,0,1,2.56-2.56H250.42A2.56,2.56,0,0,1,253,231.1v68.49A4,4,0,0,1,249,303.54Zm-125.89-74a1.56,1.56,0,0,0-1.56,1.56v68.49a3,3,0,0,0,3,3H249a3,3,0,0,0,2.95-3V231.1a1.56,1.56,0,0,0-1.56-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14,229H250.42a2.06,2.06,0,0,1,2.06,2.06v10a0,0,0,0,1,0,0H121.08a0,0,0,0,1,0,0v-10A2.06,2.06,0,0,1,123.14,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.48,241.61H121.08a.5.5,0,0,1-.5-.5v-10a2.56,2.56,0,0,1,2.56-2.56H250.42A2.56,2.56,0,0,1,253,231.1v10A.5.5,0,0,1,252.48,241.61Zm-130.9-1H252V231.1a1.56,1.56,0,0,0-1.56-1.56H123.14a1.56,1.56,0,0,0-1.56,1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.58,
    cy: 235.26,
    r: 2.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.58,238.43a3.18,3.18,0,1,1,3.17-3.17A3.18,3.18,0,0,1,225.58,238.43Zm0-5.35a2.18,2.18,0,1,0,2.17,2.18A2.19,2.19,0,0,0,225.58,233.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.04,
    cy: 235.26,
    r: 2.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,238.43a3.18,3.18,0,1,1,3.18-3.17A3.17,3.17,0,0,1,234,238.43Zm0-5.35a2.18,2.18,0,1,0,2.18,2.18A2.18,2.18,0,0,0,234,233.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.51,
    cy: 235.26,
    r: 2.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.51,238.43a3.18,3.18,0,1,1,3.17-3.17A3.18,3.18,0,0,1,242.51,238.43Zm0-5.35a2.18,2.18,0,1,0,2.17,2.18A2.19,2.19,0,0,0,242.51,233.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.17,
    y: 252.65,
    width: 26.98,
    height: 25.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,278.93h-28V252.15h28Zm-27-1h26V253.15h-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 255.15,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 263.54,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 271.94,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 280.33,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,224.29H247.25a2.06,2.06,0,0,1,2.06,2.06v68.49a3.45,3.45,0,0,1-3.45,3.45H121.36a3.45,3.45,0,0,1-3.45-3.45V226.35A2.06,2.06,0,0,1,120,224.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,298.79H121.36a4,4,0,0,1-4-4V226.35a2.56,2.56,0,0,1,2.56-2.56H247.25a2.56,2.56,0,0,1,2.56,2.56v68.49A4,4,0,0,1,245.86,298.79ZM120,224.79a1.56,1.56,0,0,0-1.56,1.56v68.49a3,3,0,0,0,3,3h124.5a3,3,0,0,0,2.95-3V226.35a1.56,1.56,0,0,0-1.56-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,224.29H247.25a2.06,2.06,0,0,1,2.06,2.06v10a0,0,0,0,1,0,0H117.91a0,0,0,0,1,0,0v-10A2.06,2.06,0,0,1,120,224.29Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.31,236.86H117.91a.5.5,0,0,1-.5-.5v-10a2.56,2.56,0,0,1,2.56-2.56H247.25a2.56,2.56,0,0,1,2.56,2.56v10A.5.5,0,0,1,249.31,236.86Zm-130.9-1h130.4v-9.51a1.56,1.56,0,0,0-1.56-1.56H120a1.56,1.56,0,0,0-1.56,1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.41,
    cy: 230.51,
    r: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,233.68a3.18,3.18,0,1,1,3.17-3.17A3.17,3.17,0,0,1,222.41,233.68Zm0-5.35a2.18,2.18,0,1,0,2.17,2.18A2.18,2.18,0,0,0,222.41,228.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.88,
    cy: 230.51,
    r: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.88,233.68a3.18,3.18,0,1,1,3.17-3.17A3.18,3.18,0,0,1,230.88,233.68Zm0-5.35a2.18,2.18,0,1,0,2.17,2.18A2.19,2.19,0,0,0,230.88,228.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.34,
    cy: 230.51,
    r: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,233.68a3.18,3.18,0,1,1,3.17-3.17A3.17,3.17,0,0,1,239.34,233.68Zm0-5.35a2.18,2.18,0,1,0,2.17,2.18A2.18,2.18,0,0,0,239.34,228.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,274.18h-28V247.4h28Zm-27-1h26V248.4h-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.98,
    y: 250.4,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.98,
    y: 258.79,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.98,
    y: 267.18,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.98,
    y: 275.58,
    width: 70.76,
    height: 1,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.37,
    y: 174.73,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,263H273.74a4.88,4.88,0,0,1-4.87-4.87v-79a4.87,4.87,0,0,1,4.87-4.87h91.08a4.88,4.88,0,0,1,4.87,4.87v79A4.88,4.88,0,0,1,364.82,263Zm-91.08-87.75a3.87,3.87,0,0,0-3.87,3.87v79a3.88,3.88,0,0,0,3.87,3.87h91.08a3.88,3.88,0,0,0,3.87-3.87v-79a3.87,3.87,0,0,0-3.87-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 169.97,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,258.23H270.57a4.88,4.88,0,0,1-4.87-4.87v-79a4.88,4.88,0,0,1,4.87-4.88h91.08a4.88,4.88,0,0,1,4.87,4.88v79A4.88,4.88,0,0,1,361.65,258.23Zm-91.08-87.76a3.88,3.88,0,0,0-3.87,3.88v79a3.88,3.88,0,0,0,3.87,3.87h91.08a3.88,3.88,0,0,0,3.87-3.87v-79a3.88,3.88,0,0,0-3.87-3.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.91,
    y: 205.11,
    width: 9.21,
    height: 42.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.11,248.19h-9.2a.5.5,0,0,1-.5-.5V205.11a.5.5,0,0,1,.5-.5h9.2a.5.5,0,0,1,.5.5v42.58A.5.5,0,0,1,288.11,248.19Zm-8.7-1h8.2V205.61h-8.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.95,
    y: 212.01,
    width: 9.21,
    height: 35.67,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.15,248.19H292a.5.5,0,0,1-.5-.5V212a.5.5,0,0,1,.5-.5h9.2a.5.5,0,0,1,.5.5v35.67A.5.5,0,0,1,301.15,248.19Zm-8.7-1h8.2V212.52h-8.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.99,
    y: 217.77,
    width: 9.21,
    height: 29.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.19,248.19H305a.5.5,0,0,1-.5-.5V217.77a.5.5,0,0,1,.5-.5h9.2a.5.5,0,0,1,.5.5v29.92A.5.5,0,0,1,314.19,248.19Zm-8.7-1h8.2V218.27h-8.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.03,
    y: 200.12,
    width: 9.21,
    height: 47.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.23,248.19H318a.5.5,0,0,1-.5-.5V200.12a.5.5,0,0,1,.5-.5h9.2a.5.5,0,0,1,.5.5v47.57A.5.5,0,0,1,327.23,248.19Zm-8.7-1h8.2V200.62h-8.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.07,
    y: 205.88,
    width: 9.21,
    height: 41.81,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,248.19h-9.2a.5.5,0,0,1-.5-.5V205.88a.5.5,0,0,1,.5-.5h9.2a.5.5,0,0,1,.5.5v41.81A.5.5,0,0,1,340.27,248.19Zm-8.7-1h8.2V206.38h-8.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.11,
    y: 185.93,
    width: 9.21,
    height: 61.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32,248.19h-9.21a.5.5,0,0,1-.5-.5V185.93a.5.5,0,0,1,.5-.5h9.21a.51.51,0,0,1,.5.5v61.76A.51.51,0,0,1,353.32,248.19Zm-8.71-1h8.21V186.43h-8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.53,
    y: 181,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.53,
    y: 184.83,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.53,
    y: 188.67,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.8,
    y: 181,
    width: 37.2,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.8,
    y: 184.83,
    width: 37.2,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.8,
    y: 188.67,
    width: 37.2,
    height: 1,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.37,
    y: 70.76,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,159H273.74a4.88,4.88,0,0,1-4.87-4.87v-79a4.87,4.87,0,0,1,4.87-4.87h91.08a4.88,4.88,0,0,1,4.87,4.87v79A4.88,4.88,0,0,1,364.82,159ZM273.74,71.26a3.87,3.87,0,0,0-3.87,3.87v79a3.88,3.88,0,0,0,3.87,3.87h91.08a3.88,3.88,0,0,0,3.87-3.87v-79a3.87,3.87,0,0,0-3.87-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 66,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,154.26H270.57a4.88,4.88,0,0,1-4.87-4.87v-79a4.88,4.88,0,0,1,4.87-4.88h91.08a4.88,4.88,0,0,1,4.87,4.88v79A4.88,4.88,0,0,1,361.65,154.26ZM270.57,66.5a3.88,3.88,0,0,0-3.87,3.88v79a3.88,3.88,0,0,0,3.87,3.87h91.08a3.88,3.88,0,0,0,3.87-3.87v-79a3.88,3.88,0,0,0-3.87-3.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.67,
    cy: 108.07,
    r: 28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,136.56a28.5,28.5,0,1,1,20.15-48.64h0a28.49,28.49,0,0,1-20.15,48.64Zm0-56a27.49,27.49,0,1,0,19.44,8A27.41,27.41,0,0,0,313.67,80.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.84,101.32a28,28,0,0,0-47-13l19.8,19.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,108.57a.54.54,0,0,1-.36-.14l-19.8-19.8a.52.52,0,0,1-.14-.36.52.52,0,0,1,.14-.35,28.51,28.51,0,0,1,47.82,13.28.51.51,0,0,1-.37.61l-27.17,6.75ZM294.58,88.28l19.24,19.24L340.23,101a27.5,27.5,0,0,0-45.65-12.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.84,101.32l-27.17,6.75-8.09,26.81a28,28,0,0,0,35.26-33.56Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,136.58a28.39,28.39,0,0,1-8.23-1.22.48.48,0,0,1-.3-.24.51.51,0,0,1,0-.38l8.09-26.81a.48.48,0,0,1,.36-.34l27.17-6.75a.5.5,0,0,1,.38.06.5.5,0,0,1,.23.3,28.51,28.51,0,0,1-27.66,35.38Zm-7.46-2a27.5,27.5,0,0,0,34.26-32.61l-26.41,6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.19 90.74 324.39 90.12 333.75 78.04 339.75 78.04 339.75 79.04 334.24 79.04 325.19 90.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.12,
    y: 78.42,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.12,
    y: 82.26,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.12,
    y: 86.09,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.12,
    y: 128.28,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.12,
    y: 132.12,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.12,
    y: 135.96,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 127.52,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 131.35,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 135.19,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.83 136.19 285.28 136.19 285.28 135.19 294.15 135.19 297.48 126.69 298.41 127.05 294.83 136.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.99 121.11 349.99 121.11 349.99 116.63 335.14 116.63 335.14 115.63 350.99 115.63 350.99 121.11",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.61,
    y: 71.08,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.06,159.34H154a4.88,4.88,0,0,1-4.87-4.87v-79A4.88,4.88,0,0,1,154,70.58h91.08a4.88,4.88,0,0,1,4.87,4.87v79A4.88,4.88,0,0,1,245.06,159.34ZM154,71.58a3.88,3.88,0,0,0-3.87,3.87v79a3.88,3.88,0,0,0,3.87,3.87h91.08a3.88,3.88,0,0,0,3.87-3.87v-79a3.88,3.88,0,0,0-3.87-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.38,
    y: 66,
    width: 99.82,
    height: 87.75,
    rx: 4.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.83,154.26H149.75a4.88,4.88,0,0,1-4.87-4.87v-79a4.88,4.88,0,0,1,4.87-4.88h91.08a4.88,4.88,0,0,1,4.87,4.88v79A4.88,4.88,0,0,1,240.83,154.26ZM149.75,66.5a3.88,3.88,0,0,0-3.87,3.88v79a3.88,3.88,0,0,0,3.87,3.87h91.08a3.88,3.88,0,0,0,3.87-3.87v-79a3.88,3.88,0,0,0-3.87-3.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.24,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.37,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.5,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.63,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.76,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.89,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.02,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.15,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.28,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.54,
    y: 137.15,
    width: 1,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.65 89.72 224.84 94.47 217.73 80.24 208.58 92.09 200.45 84.98 192.66 76.17 184.53 85.66 176.4 108.69 167.59 100.22 158.79 106.66 158.79 128 233.65 128 233.65 89.72",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,128.5H158.79a.5.5,0,0,1-.5-.5V106.66a.48.48,0,0,1,.2-.4l8.81-6.44a.51.51,0,0,1,.64,0l8.25,7.93,7.87-22.3a.51.51,0,0,1,.09-.16l8.13-9.48a.48.48,0,0,1,.38-.18.52.52,0,0,1,.38.17l7.79,8.81,7.68,6.72,8.82-11.44a.51.51,0,0,1,.45-.19.49.49,0,0,1,.39.27l6.89,13.77,8.35-4.5a.5.5,0,0,1,.49,0,.5.5,0,0,1,.25.43V128A.5.5,0,0,1,233.65,128.5Zm-74.36-1h73.86V90.56l-8.07,4.35a.53.53,0,0,1-.39,0,.5.5,0,0,1-.3-.25l-6.75-13.52L209,92.4a.49.49,0,0,1-.35.19.49.49,0,0,1-.38-.12l-8.13-7.11-7.45-8.43-7.7,9-8.1,23a.49.49,0,0,1-.35.32.51.51,0,0,1-.47-.13l-8.5-8.18-8.26,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.99,
    y: 75.48,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.99,
    y: 79.32,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.99,
    y: 83.15,
    width: 9.21,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.65 108.48 224.84 111.74 217.73 95.92 208.58 107 200.45 104.29 192.66 121.22 184.53 98.53 176.4 121.22 167.59 112.76 158.79 123.94 158.79 132.06 233.65 132.06 233.65 108.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,132.56H158.79a.5.5,0,0,1-.5-.5v-8.13a.5.5,0,0,1,.1-.31l8.81-11.17a.52.52,0,0,1,.36-.19.53.53,0,0,1,.38.14l8.25,7.93,7.87-22a.5.5,0,0,1,.47-.33h0a.5.5,0,0,1,.47.33l7.72,21.54L200,104.08a.5.5,0,0,1,.61-.27l7.8,2.6,8.93-10.81a.5.5,0,0,1,.84.11l6.93,15.4,8.36-3.1a.47.47,0,0,1,.46.06.48.48,0,0,1,.22.41v23.58A.5.5,0,0,1,233.65,132.56Zm-74.36-1h73.86V109.2l-8.14,3a.51.51,0,0,1-.63-.26l-6.78-15.1L209,107.32a.5.5,0,0,1-.55.15l-7.7-2.57-7.61,16.53a.48.48,0,0,1-.47.29.49.49,0,0,1-.45-.33L184.53,100l-7.66,21.38a.49.49,0,0,1-.35.32.51.51,0,0,1-.47-.13l-8.4-8.08-8.36,10.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413,114.54s-3.32-8.78-12.81-7.83-13.75,8.54-12.09,13.52a42.71,42.71,0,0,0,2.61,6.65s-3.09-1.43-2.14,3.55,8.07,4,9.25,3.56S404.23,120.23,413,114.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,134.89a9,9,0,0,1-4.24-.93,4.77,4.77,0,0,1-2.49-3.43c-.39-2.05-.19-3.35.62-4a1.79,1.79,0,0,1,1.11-.36c-.44-1-1.18-2.78-2.19-5.8A9.39,9.39,0,0,1,389,112.5a14.77,14.77,0,0,1,11.17-6.28c9.77-1,13.3,8,13.33,8.14a.52.52,0,0,1-.19.6c-6.14,4-10.6,11.9-13,16.15-1.31,2.34-1.79,3.15-2.27,3.35A10.81,10.81,0,0,1,394.81,134.89Zm-5-7.7a.85.85,0,0,0-.51.15c-.26.21-.65.88-.25,3a3.83,3.83,0,0,0,2,2.74,10,10,0,0,0,6.59.45,22.22,22.22,0,0,0,1.77-2.91c2.39-4.25,6.81-12.09,13-16.27-.74-1.62-4.13-7.94-12.14-7.14A13.8,13.8,0,0,0,389.81,113a8.42,8.42,0,0,0-1.24,7,44,44,0,0,0,2.57,6.55.5.5,0,0,1-.64.7A2.06,2.06,0,0,0,389.82,127.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.58,199.67l-16.84,8.42a1.87,1.87,0,0,0-.08,3.3l44.93,25.27a1.87,1.87,0,0,0,2.34-.41L393.48,224a1.88,1.88,0,0,0-.51-2.86L354.33,199.7A1.87,1.87,0,0,0,352.58,199.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.51,237.4a2.39,2.39,0,0,1-1.16-.3l-44.93-25.28a2.36,2.36,0,0,1,.1-4.18l16.84-8.42a2.4,2.4,0,0,1,2.21,0l38.64,21.42a2.33,2.33,0,0,1,1.18,1.66,2.36,2.36,0,0,1-.53,2l-10.55,12.28A2.36,2.36,0,0,1,381.51,237.4Zm-28.7-37.29L336,208.53a1.37,1.37,0,0,0-.06,2.42l44.93,25.28a1.38,1.38,0,0,0,1.71-.3l10.55-12.28a1.38,1.38,0,0,0,.31-1.14,1.34,1.34,0,0,0-.69-.95l-38.64-21.42A1.36,1.36,0,0,0,352.81,200.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.65,214.84l-7.09-4.6s-5.31-6-7.3-7-15.36,1.4-15.36,1.4l29.38,16.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,221.8a.5.5,0,0,1-.24-.06l-29.38-16.62a.5.5,0,0,1,.15-.93c1.39-.25,13.59-2.41,15.67-1.35s6.85,6.4,7.41,7l7,4.56a.46.46,0,0,1,.22.44l-.36,6.47a.5.5,0,0,1-.5.47Zm-27.92-16.87,27.47,15.54.3-5.37-6.84-4.44a.22.22,0,0,1-.1-.09c-1.46-1.63-5.59-6-7.16-6.84C377.8,203.11,370.5,204.06,365.36,204.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.17,207.58s-5.22.23-8.44-1.14-5.07-.73-3.39,2,6.89,2.47,6.89,2.47,4.55,5.54,10.07,3.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71,215.26c-3.91,0-7-3.07-7.7-3.87-1.09,0-5.49-.11-7.1-2.71-.79-1.28-.92-2.26-.38-2.89.69-.79,2.25-.73,4.4.19,3.08,1.31,8.17,1.1,8.22,1.1a.47.47,0,0,1,.52.48.51.51,0,0,1-.48.52c-.21,0-5.37.22-8.66-1.18-1.82-.78-3-.78-3.24-.46s-.13.75.47,1.71c1.5,2.43,6.4,2.24,6.45,2.24a.49.49,0,0,1,.41.18c0,.05,4.39,5.23,9.5,3.22a.5.5,0,1,1,.37.93A7.49,7.49,0,0,1,381.71,215.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,446.43s3,11.41,2.73,13.39-6.45,3.72-9.92,3.72a84.17,84.17,0,0,0-10.42,1.24l.25-18.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,465.28a.47.47,0,0,1-.32-.12.48.48,0,0,1-.18-.38l.25-18.36a.5.5,0,0,1,.5-.49H451a.48.48,0,0,1,.48.37c.31,1.18,3,11.56,2.75,13.58-.31,2.45-6.94,4.16-10.42,4.16a84.66,84.66,0,0,0-10.33,1.23Zm.74-18.35-.23,17.26a76.6,76.6,0,0,1,9.91-1.15c3.56,0,9.23-1.76,9.42-3.28s-1.74-9.43-2.62-12.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.73,459.82a13.24,13.24,0,0,0-.33-3,41.47,41.47,0,0,1-7.61,3.21c-4.21,1.21-10.22,1.27-12.35,1.25l-.05,3.46a84.17,84.17,0,0,1,10.42-1.24C447.28,463.54,453.48,461.81,453.73,459.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,465.28a.47.47,0,0,1-.32-.12.48.48,0,0,1-.18-.38l.05-3.46a.5.5,0,0,1,.5-.5h0c2.32,0,8.11-.06,12.22-1.23a41.47,41.47,0,0,0,7.51-3.17.48.48,0,0,1,.45,0,.5.5,0,0,1,.27.36,13.15,13.15,0,0,1,.34,3.11c-.31,2.45-6.94,4.16-10.42,4.16a84.66,84.66,0,0,0-10.33,1.23Zm.54-3.45,0,2.36a76.6,76.6,0,0,1,9.91-1.15c3.56,0,9.23-1.76,9.42-3.28a8.63,8.63,0,0,0-.2-2.14,40.59,40.59,0,0,1-7.1,2.93A49,49,0,0,1,434,461.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.92,336.8s3.22,27,4.46,32.25,7.44,14.13,9.92,28,7.2,46.13,7.2,46.88.49,3,.74,4.46c0,0-5.46,2.24-9.42,1.74a56.08,56.08,0,0,1-7.44-1.49s1.73-10.66-2-29.76S426,380,423.72,366.07,429.92,336.8,429.92,336.8Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.05,450.72a11.09,11.09,0,0,1-1.3-.07,56.6,56.6,0,0,1-7.51-1.51.51.51,0,0,1-.36-.56c0-.11,1.68-10.82-2-29.59-4.48-23-7.74-40.78-9.68-52.84-2.23-13.9,6.18-29.43,6.26-29.59a.5.5,0,0,1,.94.19c0,.27,3.23,27.06,4.45,32.18a43.34,43.34,0,0,0,2.74,6.85A84.52,84.52,0,0,1,444.8,397c2.41,13.52,7.2,46.1,7.2,47a24.34,24.34,0,0,0,.43,2.72c.11.58.22,1.16.3,1.66a.5.5,0,0,1-.3.55A26.19,26.19,0,0,1,444.05,450.72Zm-8.12-2.43a53.27,53.27,0,0,0,6.95,1.36c3.2.4,7.52-1.08,8.8-1.56-.07-.39-.15-.81-.23-1.24A22.34,22.34,0,0,1,451,444c0-.85-4.66-32.63-7.19-46.79a83.48,83.48,0,0,0-7.11-21,43.54,43.54,0,0,1-2.8-7c-1.07-4.49-3.55-24.66-4.28-30.65-2,4.15-7.19,16.38-5.41,27.48,1.94,12.05,5.19,29.82,9.67,52.81C437.16,435.62,436.2,446.06,435.93,448.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.27,443.45a30.77,30.77,0,0,1-5.7,6.2c-4.22,3.72-12.16,7.69-14.39,8.68s-4,1-3.47,3.23,4.21,4,15.38,4,23.06-.5,24.3-.75,5-.25,5-3-1.24-13.64-1.24-13.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.09,466c-10.17,0-15.21-1.39-15.87-4.36-.49-2.19.95-2.72,2.47-3.28.4-.15.83-.31,1.29-.51,1.92-.86,10-4.82,14.25-8.6a30.49,30.49,0,0,0,5.61-6.08.51.51,0,0,1,.55-.23l19.84,4.71a.5.5,0,0,1,.38.43c.05.45,1.24,11,1.24,13.7s-3.05,3.15-4.68,3.36l-.68.1C432.22,465.53,420.38,466,409.09,466Zm8.41-22a34.34,34.34,0,0,1-5.6,6c-4.39,3.87-12.57,7.89-14.52,8.76-.47.21-.93.38-1.35.54-1.65.61-2.12.84-1.83,2.12.36,1.63,3.24,3.58,14.89,3.58,11,0,23-.5,24.2-.74.2,0,.46-.07.75-.11,1.93-.25,3.81-.64,3.81-2.37,0-2.4-1-11.35-1.2-13.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,464.78c1.24-.25,5-.25,5-3,0-.4,0-1-.07-1.68-4.25.56-13.87,1.75-24.73,2.67a48.85,48.85,0,0,1-19.92-2,3,3,0,0,0,.08.8c.49,2.23,4.21,4,15.38,4S432.15,465,433.39,464.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.09,466c-10.17,0-15.21-1.39-15.87-4.36a3.85,3.85,0,0,1-.09-.93.51.51,0,0,1,.22-.39.51.51,0,0,1,.45-.06,48.26,48.26,0,0,0,19.71,2c10.67-.9,20.06-2.06,24.7-2.67a.6.6,0,0,1,.39.11.54.54,0,0,1,.18.36c.05.7.07,1.3.07,1.71,0,2.75-3.05,3.15-4.68,3.36l-.68.1C432.22,465.53,420.38,466,409.09,466Zm-14.89-4.55c.39,1.62,3.3,3.55,14.89,3.55,11,0,23-.5,24.2-.74.2,0,.46-.07.75-.11,1.93-.25,3.81-.64,3.81-2.37,0-.29,0-.67,0-1.11-4.81.62-13.92,1.72-24.22,2.6A50.12,50.12,0,0,1,394.2,461.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,279.76a345.92,345.92,0,0,0,2.48,41.67c2.73,22.07,10.67,48.86,10.67,48.86s4,21.57,5.2,29S417,436,417,436l-2.73,3.72.5,6.45,9.92,2.23a50.18,50.18,0,0,0,12.4,1.49s.5-12.9.25-14.63-1.74-9.92-2-12.65.49-33-1.24-39.93-4.72-17.12-4.72-26,6.7-52.58,6.7-52.58,7.19-10.17,7.19-16.13a41,41,0,0,0-.74-8.92Z",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.39,450.42a55,55,0,0,1-11.79-1.52l-9.92-2.23a.51.51,0,0,1-.39-.45l-.49-6.45a.47.47,0,0,1,.09-.33l2.6-3.54c-.6-2.72-6.48-29.49-7.65-36.51-1.22-7.35-5.17-28.8-5.21-29s-8-27-10.67-48.89a350.45,350.45,0,0,1-2.48-41.74.49.49,0,0,1,.49-.49l51.59-.74h0a.48.48,0,0,1,.48.37,41.26,41.26,0,0,1,.76,9.05c0,5.8-6.43,15.19-7.21,16.32-.39,2.5-6.68,43.82-6.68,52.39,0,7.67,2.19,16.16,3.95,23q.4,1.55.75,2.94c1.27,5.09,1.23,22.29,1.2,32.57,0,3.74,0,6.7.05,7.43.17,1.85.91,6.21,1.45,9.39.25,1.48.46,2.68.54,3.24.25,1.76-.23,14.19-.25,14.72a.49.49,0,0,1-.47.48S436.84,450.42,436.39,450.42Zm-21.13-4.65,9.56,2.16a54.83,54.83,0,0,0,11.81,1.48c.17-4.56.42-12.78.24-14.07-.08-.55-.29-1.75-.53-3.21-.55-3.2-1.29-7.58-1.46-9.47-.07-.77-.07-3.6-.06-7.52,0-10.24.07-27.36-1.17-32.33-.23-.92-.48-1.9-.75-2.93-1.77-6.88-4-15.43-4-23.23,0-8.87,6.43-50.88,6.71-52.66a.49.49,0,0,1,.08-.21c.07-.1,7.1-10.11,7.1-15.84a45.92,45.92,0,0,0-.64-8.42l-50.69.73A349.13,349.13,0,0,0,394,321.37c2.69,21.77,10.57,48.51,10.64,48.78s4,21.71,5.23,29.07,7.62,36.39,7.68,36.68a.54.54,0,0,1-.08.41l-2.62,3.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.34,445.48a.37.37,0,0,1-.37-.3s-.4-2-1.19-4.75c-.69-2.44.3-3.52.77-3.89-.06-.86-.31-4.23-.78-8.89a.37.37,0,0,1,.33-.41.37.37,0,0,1,.42.33c.54,5.43.79,9.1.79,9.14a.38.38,0,0,1-.2.36c-.05,0-1.3.72-.61,3.15.8,2.77,1.2,4.79,1.21,4.81a.38.38,0,0,1-.3.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.63,423.27a.39.39,0,0,1-.37-.34c-.44-3.9-.94-7.68-1.48-11.25-.78-5.14-2.32-12.21-4.09-20.4-2.78-12.83-6.24-28.79-8.67-45.76A189.32,189.32,0,0,1,409.75,308a.37.37,0,1,1,.74.05,188.69,188.69,0,0,0,1.28,37.42c2.42,16.94,5.87,32.89,8.65,45.7,1.78,8.2,3.32,15.28,4.1,20.45.54,3.57,1,7.37,1.49,11.28a.38.38,0,0,1-.33.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.44,304h0a.37.37,0,0,1-.34-.41c.59-7.06,1.35-11.5,1.35-11.54a.37.37,0,1,1,.74.12c0,.05-.75,4.46-1.34,11.48A.39.39,0,0,1,410.44,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.86,122.61s3.08-12.34,21.58-10.92S478.71,130,478.71,130l-4-1.9s3.32,9.73-.48,16.84-13.52,11.15-19.92,10S441,147.75,440,144.43,442.65,129.49,438.86,122.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.63,155.57a13.68,13.68,0,0,1-2.44-.21c-6.73-1.25-13.66-7.42-14.63-10.79-.35-1.25-.14-3.41.14-6.13.47-4.75,1.12-11.25-1.28-15.59a.5.5,0,0,1-.05-.36c0-.13,3.42-12.74,22.11-11.29s18.73,18.59,18.73,18.77a.47.47,0,0,1-.24.41.49.49,0,0,1-.47,0l-3-1.42c.75,2.78,2.31,10.26-.84,16.15C471.12,151.75,463,155.57,456.63,155.57Zm-17.24-33c2.44,4.61,1.78,11.18,1.3,16-.25,2.51-.47,4.69-.16,5.75.87,3.06,7.56,8.92,13.84,10.09,6.1,1.13,15.7-2.78,19.39-9.71s.48-16.35.44-16.45a.52.52,0,0,1,.14-.53.49.49,0,0,1,.55-.08l3.29,1.55c-.2-3.33-2-15.76-17.77-17C443.58,110.89,439.86,121,439.39,122.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,121.18s-1.42,2.38-4.27,7.36-1.66,9.48-3.56,11.86-7.11,2.13-6.4,4.5,3.79,4,3.79,4,0,13.28,1.43,14.94,12.33-1.19,12.33-1.19,2.14,3.33.71,10.68-14.23,27.75-15.89,37.95,4,35.58,4,35.58l-5.45,37a75.68,75.68,0,0,0,30.12,3.79c16.37-1.42,26.33-4.74,26.33-4.74L434.35,240s.95-30.36-1.18-47.2-7.59-20.87-7.59-27,7.82-9.49,12.8-15.42a24.89,24.89,0,0,0,2.38-25.86c-3.89-8.39-16.37-11.62-24.91-11.86S402.09,121.18,402.09,121.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.23,288.45a77.62,77.62,0,0,1-24.6-4.07.52.52,0,0,1-.32-.55l5.45-36.91c-.43-1.93-5.65-25.7-4-35.68.93-5.71,5.33-14.62,9.21-22.48,3.12-6.31,6.06-12.26,6.68-15.49,1.13-5.79,0-9-.48-10-3,.76-11,2.61-12.45.93s-1.54-12.19-1.55-15c-.79-.48-3.13-2-3.77-4.18-.53-1.77,1.28-2.42,3-3.05a7.72,7.72,0,0,0,3.47-1.92c.79-1,1-2.41,1.25-4.23a20.14,20.14,0,0,1,2.27-7.56c2.81-4.93,4.26-7.34,4.27-7.36.23-.39,5.34-8.79,13.84-8.79h.36c7.42.21,21.11,3,25.35,12.15,5.54,12,.83,22.5-2.44,26.39A47.18,47.18,0,0,1,433,156.2c-3.69,3.1-6.87,5.78-6.87,9.58,0,2.48.91,4.59,2.18,7.52a64.37,64.37,0,0,1,5.4,19.46c2.07,16.29,1.24,45.56,1.19,47.21l10.9,42.87a.5.5,0,0,1-.33.59c-.1,0-10.21,3.36-26.44,4.77C417,288.37,415.1,288.45,413.23,288.45Zm-23.87-4.88a76.37,76.37,0,0,0,29.53,3.64,130.84,130.84,0,0,0,25.77-4.59l-10.79-42.47a.68.68,0,0,1,0-.14c0-.3.93-30.52-1.18-47.13a63.41,63.41,0,0,0-5.33-19.19c-1.27-2.92-2.26-5.23-2.26-7.91,0-4.26,3.51-7.22,7.22-10.35A46,46,0,0,0,438,150c3.13-3.73,7.63-13.81,2.3-25.33-4-8.71-17.27-11.37-24.46-11.57h-.33c-8,0-12.94,8.21-13,8.3h0s-1.45,2.43-4.26,7.34a18.91,18.91,0,0,0-2.15,7.21c-.26,1.89-.5,3.52-1.46,4.72a8.44,8.44,0,0,1-3.91,2.23c-1.85.67-2.64,1-2.4,1.82.64,2.15,3.52,3.72,3.55,3.74a.49.49,0,0,1,.26.44c0,5.06.36,13.51,1.31,14.61.75.88,6.72,0,11.83-1.34a.49.49,0,0,1,.54.21c.09.15,2.23,3.58.79,11-.65,3.36-3.63,9.37-6.77,15.74-3.85,7.8-8.22,16.64-9.13,22.2-1.62,10,4,35.14,4,35.39a.61.61,0,0,1,0,.19Zm12.73-162.39h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,162.69l5.2-1.16L407.37,168A18.6,18.6,0,0,0,405.41,162.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.37,168.51h-.06a.5.5,0,0,1-.43-.4A18.36,18.36,0,0,0,405,163a.5.5,0,0,1,0-.46.46.46,0,0,1,.35-.3l5.2-1.17a.52.52,0,0,1,.51.18.49.49,0,0,1,.05.53l-3.24,6.49A.5.5,0,0,1,407.37,168.51ZM406.19,163a17.64,17.64,0,0,1,1.34,3.54l2.17-4.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.26,283,434.35,240s.95-30.36-1.18-47.2a69.44,69.44,0,0,0-2.25-11c-3.49-2.71-8.87-6.13-14.36-6.55-6.37-.49-12.73,6.88-16.08,11.53-4.18,8.48-9.25,18.36-10.25,24.52-1.66,10.2,4,35.58,4,35.58l-5.45,37a75.68,75.68,0,0,0,30.12,3.79C435.3,286.28,445.26,283,445.26,283Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.23,288.45a77.62,77.62,0,0,1-24.6-4.07.52.52,0,0,1-.32-.55l5.45-36.91c-.43-1.93-5.65-25.7-4-35.68.93-5.71,5.33-14.62,9.21-22.48l1.08-2.18c3.36-4.68,9.91-12.32,16.57-11.81,5.57.43,11,3.86,14.63,6.66a.49.49,0,0,1,.17.25,69,69,0,0,1,2.26,11.08c2.07,16.29,1.24,45.56,1.19,47.21l10.9,42.87a.5.5,0,0,1-.33.59c-.1,0-10.21,3.36-26.44,4.77C417,288.37,415.1,288.45,413.23,288.45Zm-23.87-4.88a76.37,76.37,0,0,0,29.53,3.64,130.84,130.84,0,0,0,25.77-4.59l-10.79-42.47a.68.68,0,0,1,0-.14c0-.3.93-30.52-1.18-47.13a68.85,68.85,0,0,0-2.18-10.76c-3.49-2.7-8.71-6-14-6.36-6.17-.47-12.44,6.9-15.64,11.33l-1,2.11c-3.85,7.8-8.22,16.64-9.13,22.2-1.62,10,4,35.14,4,35.39a.61.61,0,0,1,0,.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.85,112.64c-8.54-.23-13.76,8.54-13.76,8.54s-.74,1.24-2.22,3.8c1.48-1.76,6.86-7.53,9.1-1.42,1.31,3.56-1.9,8.53-.24,10.2s5,5.45,4.51,6.16a7.82,7.82,0,0,0-.71,2.37s4.27-6.16,7.59-2.37-1.19,10.91-1.19,10.91l-2.84.95s9.25,10.44,10.91,10.44c.46,0,1.66-3.56,3.79-4.27a74.84,74.84,0,0,0,7.59-7.59,24.89,24.89,0,0,0,2.38-25.86C436.87,116.11,424.39,112.88,415.85,112.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,162.72c-1.75,0-9.08-8.12-11.29-10.61a.5.5,0,0,1-.11-.46.51.51,0,0,1,.33-.34l2.67-.89c.6-1,3.93-7,1.14-10.17a2.63,2.63,0,0,0-2.19-1.06c-2.32.13-4.59,3.36-4.61,3.39a.49.49,0,0,1-.59.18.51.51,0,0,1-.32-.54,8.45,8.45,0,0,1,.75-2.51c-.07-.67-2.25-3.45-4.4-5.6-1-1-.62-2.77-.16-4.8.42-1.84.89-3.92.28-5.58-.52-1.42-1.24-2.22-2.15-2.38-2.23-.39-5.23,2.92-6.1,4a.5.5,0,0,1-.81-.57c1.48-2.56,2.22-3.8,2.22-3.8.22-.37,5.33-8.79,13.84-8.79h.36c7.42.21,21.11,3,25.35,12.15,5.54,12,.83,22.5-2.44,26.39a57.14,57.14,0,0,1-5.9,6c-.57.52-1.14,1-1.73,1.6a.45.45,0,0,1-.19.11c-1.23.41-2.17,2-2.79,3.07C427.68,162.31,427.44,162.72,427,162.72ZM417,152c4.12,4.6,8.7,9.22,9.91,9.67.11-.16.28-.46.43-.71.68-1.16,1.7-2.9,3.23-3.47.57-.54,1.12-1,1.67-1.54A55.2,55.2,0,0,0,438,150c3.13-3.73,7.63-13.81,2.3-25.33-4-8.71-17.27-11.37-24.46-11.57h-.33c-7.95,0-12.94,8.21-13,8.3l-.32.55c1.33-1,2.89-1.88,4.33-1.63,1.28.23,2.26,1.25,2.91,3,.71,1.94.2,4.18-.24,6.15-.38,1.67-.74,3.24-.11,3.87.91.91,5.42,5.53,4.57,6.8a.22.22,0,0,0-.05.08,6.59,6.59,0,0,1,3.88-2.09,3.65,3.65,0,0,1,3,1.4c3.52,4-.95,11.21-1.14,11.51a.56.56,0,0,1-.27.21ZM430.79,158h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.7,139.77c-.26,1.21-.89,2.11-1.4,2s-.72-1.18-.46-2.4.89-2.12,1.4-2S400,138.55,399.7,139.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,135.2a.48.48,0,0,1-.45-.28c-.42-.9-.92-1.4-1.49-1.49-.95-.15-1.95.89-2,.9a.5.5,0,0,1-.71,0,.51.51,0,0,1,0-.71,3.76,3.76,0,0,1,2.85-1.21,3.15,3.15,0,0,1,2.25,2.05.49.49,0,0,1-.46.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.66,152.71c-1.13,0-1.48-.55-1.56-.7a.5.5,0,0,1,.23-.67.49.49,0,0,1,.65.19c.13.15.81.39,2.48-.22a.51.51,0,0,1,.65.3.5.5,0,0,1-.3.64A6.32,6.32,0,0,1,394.66,152.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.21,188.08s-3.56,5-5,14.23-.24,39.37-.24,39.37-20.16-5.69-26.81-9a96.53,96.53,0,0,1-8.77-4.74s-2.14-5-3.8-6.88-6.16-2.37-7.82-3.56-2.85-5-5-3.56a2.33,2.33,0,0,0-.23,4c.95.72,4.5,4.27,4.5,4.27l-9-4s-.71,3.56.47,4.75,3.56,3.32,3.56,3.32,3.56,5,5.7,6.16a38.79,38.79,0,0,0,6.64,2.38c2.12.71,4.26,2.52,6.16,3.67l12.09,7.35a108.1,108.1,0,0,0,19.78,9.31c4.32,1.52,14.89,6.16,18.64,1.51,1.62-2,1.12-8,1.54-10.5,2.65-15.91,6.07-31.92,6.07-48.11",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.87,259.18c-3.94,0-8.69-1.76-12-3l-1.56-.57a108.68,108.68,0,0,1-19.87-9.35l-8-4.85-4.11-2.5c-.6-.37-1.22-.79-1.86-1.23a18.34,18.34,0,0,0-4.2-2.4l-.71-.21a32.52,32.52,0,0,1-6-2.2c-2.12-1.18-5.44-5.73-5.82-6.27-.33-.29-2.43-2.19-3.54-3.3-1.34-1.34-.69-4.81-.61-5.2a.51.51,0,0,1,.69-.36l6.49,2.9c-1-.94-2-1.94-2.48-2.28A3.1,3.1,0,0,1,350,215.9a3,3,0,0,1,1.52-2.38c1.82-1.22,3.09.51,4.1,1.91a7.79,7.79,0,0,0,1.45,1.65,12,12,0,0,0,2.94,1.18c1.83.58,3.9,1.23,5,2.46,1.55,1.77,3.45,6,3.82,6.87.53.34,2.92,1.79,8.6,4.63,5.85,2.93,22.52,7.78,26,8.79-.17-4.65-1-30.25.27-38.78,1.43-9.26,4.92-14.24,5.07-14.44a.5.5,0,0,1,.7-.12.51.51,0,0,1,.12.7s-3.51,5-4.9,14-.24,39-.23,39.29a.5.5,0,0,1-.64.5c-.82-.24-20.28-5.75-26.89-9a96.9,96.9,0,0,1-8.83-4.78.49.49,0,0,1-.18-.22c0-.05-2.12-4.93-3.71-6.74-.89-1-2.82-1.63-4.52-2.17a12.61,12.61,0,0,1-3.23-1.31,8.75,8.75,0,0,1-1.66-1.88c-1.17-1.6-1.83-2.29-2.75-1.67a2,2,0,0,0-1.07,1.58,2.12,2.12,0,0,0,.86,1.63c1,.73,4.41,4.17,4.56,4.32a.51.51,0,0,1,.06.64.5.5,0,0,1-.62.17l-8.42-3.77c-.17,1.3-.18,3.05.44,3.67,1.16,1.16,3.51,3.28,3.54,3.3l.07.09s3.52,4.9,5.53,6a31.94,31.94,0,0,0,5.81,2.11l.75.22a19.31,19.31,0,0,1,4.45,2.52c.62.43,1.23.85,1.81,1.2l4.11,2.5,8,4.85a107.62,107.62,0,0,0,19.68,9.27l1.58.57c4.67,1.74,13.38,5,16.51,1.09,1-1.25,1.12-4.44,1.21-7a29.38,29.38,0,0,1,.23-3.25c.47-2.84,1-5.69,1.47-8.54,2.26-12.89,4.59-26.23,4.59-39.49a.5.5,0,0,1,1,0c0,13.34-2.34,26.73-4.61,39.67-.49,2.84-1,5.68-1.47,8.52-.12.77-.16,1.91-.21,3.12-.1,2.86-.22,6.1-1.43,7.61S417.16,259.18,414.87,259.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.8,239.57c-6.47-2-15.56-4.87-19.62-6.9a96.53,96.53,0,0,1-8.77-4.74s-2.14-5-3.8-6.88-6.16-2.37-7.82-3.56-2.85-5-5-3.56a2.33,2.33,0,0,0-.23,4c.95.72,4.5,4.27,4.5,4.27l-9-4s-.71,3.56.47,4.75,3.56,3.32,3.56,3.32,3.56,5,5.7,6.16a38.79,38.79,0,0,0,6.64,2.38c2.12.71,4.26,2.52,6.16,3.67l12.09,7.35a107.74,107.74,0,0,0,12.09,6.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.77,252.6a.46.46,0,0,1-.2,0,106.2,106.2,0,0,1-12.15-6.29l-8-4.85-4.11-2.5c-.6-.37-1.22-.79-1.86-1.23a18.34,18.34,0,0,0-4.2-2.4l-.71-.21a32.52,32.52,0,0,1-6-2.2c-2.12-1.18-5.44-5.73-5.82-6.27-.33-.29-2.43-2.19-3.54-3.3-1.34-1.34-.69-4.81-.61-5.2a.51.51,0,0,1,.69-.36l6.49,2.9c-1-.94-2-1.94-2.48-2.28A3.1,3.1,0,0,1,350,215.9a3,3,0,0,1,1.52-2.38c1.82-1.22,3.09.52,4.1,1.91a7.79,7.79,0,0,0,1.45,1.65,12,12,0,0,0,2.94,1.18c1.83.58,3.9,1.23,5,2.46,1.55,1.77,3.45,6,3.82,6.87.53.34,2.92,1.79,8.6,4.63,4,2,12.82,4.83,19.53,6.87a.51.51,0,0,1,.35.6l-3,12.52a.5.5,0,0,1-.27.33A.46.46,0,0,1,393.77,252.6Zm-46.32-33.68c-.17,1.3-.18,3.05.44,3.67,1.16,1.16,3.51,3.28,3.54,3.3l.07.09s3.52,4.9,5.53,6a31.94,31.94,0,0,0,5.81,2.11l.75.22a19.31,19.31,0,0,1,4.45,2.52c.62.43,1.23.85,1.81,1.2l4.11,2.5,8,4.85a105.52,105.52,0,0,0,11.48,6l2.78-11.49c-6.69-2-15.29-4.82-19.24-6.79a96.9,96.9,0,0,1-8.83-4.78.49.49,0,0,1-.18-.22c0-.05-2.12-4.93-3.71-6.74-.89-1-2.82-1.63-4.52-2.17a12.61,12.61,0,0,1-3.23-1.31,8.75,8.75,0,0,1-1.66-1.88c-1.17-1.6-1.83-2.29-2.75-1.67a2,2,0,0,0-1.07,1.58,2.12,2.12,0,0,0,.86,1.63c1,.73,4.41,4.17,4.56,4.32a.51.51,0,0,1,.06.64.5.5,0,0,1-.62.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.87,249.06a.54.54,0,0,1-.36-.14L405,243.43l1.34,4.52a.51.51,0,0,1-.34.62.49.49,0,0,1-.62-.34l-1.9-6.4a.53.53,0,0,1,.22-.58.51.51,0,0,1,.61.08l6.88,6.88a.5.5,0,0,1,0,.71A.52.52,0,0,1,410.87,249.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.09,345s-4.29,25.72-9.89,49.46-4,56.71-4,56.71-3,6.27-.33,9.24,6.93,2,7.92,2,7.91-.33,7.91-.33S115,430.73,117,402.37s.33-71.55-1.65-69.9-6.26,10.22-6.26,10.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,463a7.58,7.58,0,0,1-5.86-2.3c-2.65-3-.22-8.75.2-9.67-.1-2.24-1.41-33.92,4-56.73,5.54-23.45,9.84-49.17,9.89-49.42a.53.53,0,0,1,0-.12l1-2.3c.19-.38,4.37-8.72,6.4-10.41a.64.64,0,0,1,.73-.09c2.46,1.26,3.54,44.69,1.74,70.41-2,28-7.21,59.41-7.26,59.73a.49.49,0,0,1-.47.41c-.28,0-6.94.33-7.93.33-.14,0-.34,0-.6.05A16.76,16.76,0,0,1,99.4,463Zm9.17-117.9c-.23,1.4-4.47,26.5-9.88,49.44-5.53,23.4-4,56.24-4,56.57a.42.42,0,0,1,0,.24c0,.06-2.79,6-.4,8.68,2.07,2.34,5.3,2,6.84,1.87.3,0,.54-.06.7-.06.82,0,6-.24,7.48-.31.62-3.73,5.35-32.94,7.18-59.23,1.94-27.69.43-65.17-1.11-69.21-1.59,1.67-4.47,7-5.85,9.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.57,261.58s-4,23.08-3,29.67a114.76,114.76,0,0,0,3.63,14.84s8.9,39.57,9.89,42.54,0,38.25-2,53.74,1.32,25.72,2,30.67.33,21.1.33,21.1l-.66,9.23s4.62,1.65,12.86,1.65,25.72,1,25.72,1,10.55-.33,9.56-4.94-12.86-6.93-16.15-9.9a73.1,73.1,0,0,1-5.61-5.6s.33-3.3-.33-4.95-3.3-1.65-3-3.95,5.94-54.74,10.23-68.26,7.58-68.91,7.25-78.47S143,265.87,143,265.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,466.51c-.22,0-17.6-1-25.74-1s-12.83-1.61-13-1.68a.5.5,0,0,1-.34-.5l.66-9.23c0-.14.32-16.15-.32-21-.13-1-.37-2.19-.65-3.59a79.68,79.68,0,0,1-1.33-27.2c2-15.87,2.92-50.77,2-53.52-1-3-9.54-41-9.91-42.59a116.08,116.08,0,0,1-3.63-14.87c-1-6.6,2.81-28.89,3-29.84a.52.52,0,0,1,.54-.41l48.47,4.29a.5.5,0,0,1,.45.43c0,.14,2,14.64,2.31,24.12.35,10.05-3.07,65.38-7.28,78.64-2.45,7.75-5.75,29.55-9.8,64.79-.22,1.88-.36,3.08-.4,3.39-.14,1,.37,1.39,1.28,2a3.9,3.9,0,0,1,1.66,1.7,13.6,13.6,0,0,1,.38,5,76.3,76.3,0,0,0,5.42,5.4c1.2,1.08,3.68,2.1,6.3,3.19,4.6,1.9,9.35,3.86,10,7a3,3,0,0,1-.57,2.54C150.69,466.25,143.68,466.5,143.39,466.51ZM105.32,463a44.9,44.9,0,0,0,12.33,1.5c8.17,0,25.57,1,25.75,1,0,0,6.79-.24,8.66-2.63a1.93,1.93,0,0,0,.38-1.71c-.55-2.6-5.26-4.54-9.41-6.26-2.71-1.12-5.27-2.17-6.59-3.37a75.55,75.55,0,0,1-5.64-5.64.49.49,0,0,1-.13-.38,13.61,13.61,0,0,0-.29-4.71,3.07,3.07,0,0,0-1.28-1.24c-.87-.58-2-1.3-1.72-3,0-.3.18-1.49.39-3.36,4.06-35.3,7.37-57.16,9.85-65,4.18-13.18,7.58-68.29,7.23-78.31-.3-8.55-1.93-21.23-2.25-23.62L95,262.12c-.55,3.26-3.78,23.13-2.89,29.06a114,114,0,0,0,3.61,14.76c.1.44,8.92,39.62,9.89,42.53,1.06,3.2,0,38.64-2,54A78.67,78.67,0,0,0,105,429.31c.28,1.42.52,2.65.66,3.66.66,4.93.35,20.52.33,21.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,171.58s-9.74,20.68-11.15,34.88,6.28,49.48,6.28,49.48-3,8.92-.81,10.34,51.92,4.06,51.92,4.06,3-.41,3-3-.81-4.46-1.22-6.69.61-47.87-3.85-58-13.59-22.51-13.59-22.51Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,270.84c-5.19-.27-50-2.69-52.25-4.13s0-9,.56-10.8c-.52-2.42-7.63-35.84-6.26-49.5,1.41-14.12,11.1-34.84,11.2-35a.5.5,0,0,1,.58-.27l30.63,8.52a.49.49,0,0,1,.26.19c.1.12,9.21,12.53,13.65,22.6,3.48,7.91,3.66,36.84,3.75,50.75,0,3.85.05,6.9.13,7.37.14.72.32,1.42.49,2.1a17.39,17.39,0,0,1,.74,4.68C147.78,269.73,145.51,270.67,144.3,270.84Zm-46-98.67c-1.32,2.89-9.64,21.44-10.93,34.34-1.39,14,6.2,49,6.28,49.32a.61.61,0,0,1,0,.27c-1.21,3.55-2.33,8.93-1,9.76,1.67,1,31.82,2.93,51.67,4,0,0,2.52-.38,2.52-2.54a16.37,16.37,0,0,0-.71-4.43c-.17-.7-.36-1.41-.5-2.17-.1-.54-.11-2.83-.15-7.55-.09-13.83-.27-42.63-3.67-50.34-4.13-9.41-12.42-20.89-13.43-22.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,255.88a.49.49,0,0,1-.39-.8c5.77-7.6,13.86-18.54,19.65-27.46a.5.5,0,0,1,.84.55c-5.81,8.94-13.92,19.9-19.7,27.51A.49.49,0,0,1,106.77,255.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,263.47a.51.51,0,0,1-.31-.11.49.49,0,0,1-.08-.7l2.88-3.72a.5.5,0,1,1,.79.61c-1.79,2.33-2.89,3.73-2.89,3.73A.49.49,0,0,1,100.94,263.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.13,238a.5.5,0,0,1-.16-1c1.91-.64,16.09-10.24,21.4-13.89a.5.5,0,1,1,.56.82c-.78.54-19.21,13.2-21.64,14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,116s3.25-10.75,3.86-14a24.84,24.84,0,0,1,2.23-6.28v7.91s2.43-2.84,5.07-6.29,5.07-3.24,4.05.41-3.65,7.7-3.85,8.31a59.1,59.1,0,0,1-2.43,7.71,33.14,33.14,0,0,1-4.26,6.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.24,120.36a.54.54,0,0,1-.32-.11l-4.66-3.86a.5.5,0,0,1-.17-.53c0-.1,3.25-10.76,3.85-13.94a25.24,25.24,0,0,1,2.28-6.43.5.5,0,0,1,.56-.25.51.51,0,0,1,.38.49v6.54c.94-1.13,2.52-3.07,4.17-5.22s3.26-3,4.34-2.52c.5.25,1.25,1,.6,3.36a36.43,36.43,0,0,1-3.29,7.27c-.27.47-.54,1-.58,1.07s-.12.45-.24.89A47,47,0,0,1,149,114a32.36,32.36,0,0,1-4.34,6.2A.5.5,0,0,1,144.24,120.36Zm-4.09-4.53,4,3.33a30.25,30.25,0,0,0,3.86-5.59,46.51,46.51,0,0,0,2.16-6.7c.12-.48.21-.82.26-1a9.09,9.09,0,0,1,.64-1.24,34.36,34.36,0,0,0,3.2-7c.37-1.31.23-2-.07-2.19s-1.58.24-3.11,2.22c-2.61,3.42-5.06,6.28-5.08,6.31a.5.5,0,0,1-.88-.32V98a21.43,21.43,0,0,0-1.24,4.08C143.36,105.07,140.7,114,140.15,115.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,124.12,139.57,116s3.65-.41,4.67,3.85.4,1.83.4,1.83l-10.34,14.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,136.79h0a.51.51,0,0,1-.41-.23L126,124.39a.51.51,0,0,1-.07-.38.53.53,0,0,1,.23-.32l13.18-8.11a.48.48,0,0,1,.21-.07s4.1-.4,5.2,4.24c.26,1.06.42,1.75.51,2.2a2.38,2.38,0,0,0,.07.27h0c.07.55-.05.58-.33.64a.39.39,0,0,1-.45-.09l-9.78,13.81A.52.52,0,0,1,134.3,136.79Zm-7.21-12.51,7.23,11.12,9.8-13.85c-.08-.36-.2-.87-.37-1.57-.82-3.45-3.45-3.51-4-3.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,118.85s-9.94-10.35-12.37-9.53-1.22,5.07-1.22,5.07-5.88-2.24-6.09-.61l-.2,1.62s-10.54,6.29-13.38,13-3.25,13.18,0,16.83,11.15,16.63,11.15,16.63l.2,6.29,20.08,5.07,1.83-8.52s9.53,0,10.34-1.42,1.22-17,1.22-17l4.25-5.28s-7.7-8.92-8.92-11.56A66.94,66.94,0,0,0,124.57,118.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,173.7l-.12,0-20.08-5.07a.49.49,0,0,1-.38-.47L102,162c-.78-1.28-8-13.05-11-16.45-3.2-3.6-3.23-9.93-.08-17.36,2.68-6.32,11.82-12.13,13.38-13.08l.17-1.38a1,1,0,0,1,.51-.79c1.07-.64,3.88.17,5.39.68-.24-1.42-.37-4.07,1.74-4.77,2.6-.88,11.19,7.9,12.89,9.66l0,0a68.67,68.67,0,0,1,7,10.65c1.17,2.55,8.77,11.36,8.84,11.45a.49.49,0,0,1,0,.64l-4.15,5.14c-.08,3-.46,15.67-1.28,17.1s-7.23,1.65-10.37,1.67l-1.74,8.12a.5.5,0,0,1-.22.32A.56.56,0,0,1,122.74,173.7Zm-19.59-6,19.21,4.85,1.72-8a.49.49,0,0,1,.49-.4c5,0,9.52-.53,9.9-1.17.49-.85,1-9.29,1.16-16.8a.48.48,0,0,1,.11-.3l4-4.95c-1.4-1.64-7.61-8.94-8.72-11.36a66.05,66.05,0,0,0-6.82-10.42c-4.77-5-10.51-9.83-11.84-9.39-1.95.65-.9,4.42-.89,4.46a.49.49,0,0,1-.14.5.5.5,0,0,1-.52.1c-2.11-.8-4.76-1.43-5.37-1.06l-.24,1.67a.52.52,0,0,1-.24.37c-.11.06-10.44,6.28-13.18,12.74-3,7-3,13.05-.09,16.31,3.24,3.64,10.88,16.17,11.21,16.7a.52.52,0,0,1,.07.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11,151a4.75,4.75,0,0,1-3-1.72.5.5,0,0,1,0-.71.51.51,0,0,1,.71,0c1.26,1.27,2,1.43,2.34,1.43a.46.46,0,0,0,.38-.13.51.51,0,0,1,.7-.06.5.5,0,0,1,.09.68,1.47,1.47,0,0,1-1.05.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,118.85s-9.94-10.35-12.37-9.53-1.22,5.07-1.22,5.07-5.88-2.24-6.09-.61l-.2,1.62s-10.54,6.29-13.38,13-3.25,13.18,0,16.83c2.51,2.82,7.8,11.22,10.07,14.88a14.92,14.92,0,0,0,4.12-.07c5.68-1,9.53-7.51,9.53-7.51s-3.85-1.21-4-6.28,3-6.09,3-6.09,2.84,3.25,5.27,1.83-3-4.06-3.85-6.09,1.22-4.86,1.62-6.28-3.85-1-5.47-1.83,7.09-4.87,8.92-6.08-2-.41-4.26-1.63S124.57,118.85,124.57,118.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.29,160.7a19.31,19.31,0,0,1-2-.11.51.51,0,0,1-.37-.23c-2.19-3.52-7.53-12-10-14.82-3.2-3.6-3.23-9.93-.08-17.36,2.68-6.32,11.82-12.13,13.38-13.08l.17-1.38a1,1,0,0,1,.51-.79c1.07-.64,3.88.17,5.39.68-.24-1.42-.37-4.07,1.74-4.77,2.61-.87,11.19,7.9,12.89,9.66a.51.51,0,0,1,.1.54.5.5,0,0,1-.46.31,51.61,51.61,0,0,0-7.7.45,10.12,10.12,0,0,0,2.82.55c1,.1,1.64.16,1.78.7s-.42.88-.68,1c-.52.35-1.54.9-2.72,1.53-1.81,1-5.46,2.94-6.1,3.76a11,11,0,0,0,2.35.46c1.43.18,2.66.34,3.1,1a1,1,0,0,1,.12.87,10.91,10.91,0,0,1-.65,1.55c-.66,1.41-1.49,3.16-1,4.42A8.67,8.67,0,0,0,118,138c1.29,1.13,2.5,2.19,2.4,3.25a1.56,1.56,0,0,1-.86,1.18c-2.34,1.36-4.86-.86-5.65-1.66-.72.36-2.57,1.68-2.42,5.47.18,4.63,3.56,5.78,3.71,5.83a.46.46,0,0,1,.31.3.5.5,0,0,1,0,.43c-.16.27-4,6.7-9.87,7.74A13.81,13.81,0,0,1,103.29,160.7Zm-1.61-1.08a13.75,13.75,0,0,0,3.73-.1c4.51-.8,7.89-5.31,8.89-6.79a7.23,7.23,0,0,1-3.82-6.48c-.22-5.4,3.24-6.54,3.39-6.59a.5.5,0,0,1,.53.15s2.6,2.92,4.64,1.72c.23-.13.36-.27.37-.4,0-.56-1.12-1.58-2.06-2.41a8.53,8.53,0,0,1-2.37-2.65c-.67-1.67.26-3.63,1-5.22a11.09,11.09,0,0,0,.59-1.39c-.12-.33-1.59-.52-2.38-.62a9.8,9.8,0,0,1-2.84-.62.79.79,0,0,1-.47-.71c0-1,2-2.21,6.7-4.76,1-.55,1.93-1,2.45-1.36l-.45,0a9.52,9.52,0,0,1-3.58-.85c-.57-.31-.61-.67-.55-.91s.3-1.16,7.93-1.24c-4.6-4.66-9.77-9-11-8.56-1.95.65-.9,4.42-.89,4.46a.49.49,0,0,1-.14.5.5.5,0,0,1-.52.1c-2.11-.8-4.76-1.43-5.37-1.06l-.24,1.67a.52.52,0,0,1-.24.37c-.11.06-10.44,6.28-13.18,12.74-3,7-3,13.05-.09,16.31C94.18,147.69,99.4,156,101.68,159.62Zm14.7-40.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,134.26c.4,1.11.33,2.14-.14,2.31s-1.18-.59-1.58-1.7-.33-2.14.15-2.31S129.8,133.15,130.19,134.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,131.52h-.07a.5.5,0,0,1-.42-.57c0-.13.48-3.25,2.33-4.08a2.94,2.94,0,0,1,2.9.49.5.5,0,1,1-.56.84,2,2,0,0,0-1.93-.41c-1.12.49-1.65,2.55-1.75,3.31A.51.51,0,0,1,125.58,131.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9,155a.49.49,0,0,1-.47-.34l-.87-2.6-3.4.9a.5.5,0,1,1-.25-1l3.85-1a.5.5,0,0,1,.6.33l1,3a.5.5,0,0,1-.32.63A.45.45,0,0,1,119.9,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39,164.27c.61,0,32.25,9.94,32.25,9.94l.6,9.33L96.58,173.4Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,184l-.14,0L96.44,173.88a.51.51,0,0,1-.36-.52l.81-9.13a.51.51,0,0,1,.5-.46c.62,0,22.86,7,32.4,10a.53.53,0,0,1,.35.45l.6,9.33a.49.49,0,0,1-.5.53ZM97.11,173l32.59,9.81-.54-8.26C117.67,171,101,165.78,97.84,164.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,209.09s37.72,16.43,48.07,17.44,57.19-47.65,57.19-47.65l-5.48-7.1s-38.33,19.67-43,21.29-43.4-10.75-46.24-11.35-9.13.4-11.56,3.65",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,227.05l-.35,0c-10.31-1-46.67-16.81-48.22-17.48a.5.5,0,0,1-.26-.66.49.49,0,0,1,.66-.25c.38.16,37.77,16.4,47.91,17.4,9.56.94,52.46-43,56.49-47.2l-5-6.43c-4.19,2.15-38.24,19.59-42.69,21.13-3.34,1.17-21.32-3.89-40.25-9.52-3.28-1-5.65-1.69-6.26-1.82-2.57-.54-8.71.35-11,3.47a.51.51,0,0,1-.7.1.5.5,0,0,1-.1-.7c2.49-3.33,8.91-4.52,12.06-3.84.64.13,2.91.81,6.33,1.83,10.82,3.22,36.15,10.75,39.64,9.54,4.58-1.59,42.55-21.07,42.93-21.27a.51.51,0,0,1,.63.14l5.47,7.1a.5.5,0,0,1,0,.65C207,181.2,162.73,227.05,151.64,227.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63,216.08a.49.49,0,0,1-.49-.46.5.5,0,0,1,.45-.54l14.81-1.21a.5.5,0,0,1,.54.46.51.51,0,0,1-.46.54l-14.8,1.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,183.23a.48.48,0,0,1-.39-.19l-6.08-7.5a.5.5,0,1,1,.77-.63l6.09,7.5a.5.5,0,0,1-.39.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.05,171.78l5.68-7.91,2.43-7.3c.41-1.22,4.26-3.85,5.48-5.48s2.43-5.27,3.65-4.26,1,3.25.61,4.26-2.44,3.25-2.64,4.26,12.17-2.23,12.17-2.23,2,.61,1.42,2.23a23.46,23.46,0,0,1-2.64,4.26s-2.43,7.71-4.26,9.53-10.34,4.26-10.34,4.26l-6.08,5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,179.38h-.05a.48.48,0,0,1-.35-.19l-5.48-7.1a.51.51,0,0,1,0-.59l5.64-7.85,2.41-7.23c.25-.75,1.28-1.68,2.95-3.12a20.53,20.53,0,0,0,2.6-2.5A16.1,16.1,0,0,0,217.3,149c.78-1.43,1.45-2.66,2.35-2.83a1.1,1.1,0,0,1,1,.27c1.37,1.14,1.26,3.56.75,4.83a11.72,11.72,0,0,1-1.24,1.94,17.1,17.1,0,0,0-1.22,1.84,85.13,85.13,0,0,0,11.4-2.42.42.42,0,0,1,.27,0,3,3,0,0,1,1.7,1.32,1.94,1.94,0,0,1,0,1.57,22.4,22.4,0,0,1-2.66,4.31c-.28.9-2.55,7.85-4.35,9.66s-9.39,4-10.45,4.35l-6,5.4A.51.51,0,0,1,208.53,179.38Zm-4.86-7.61,4.92,6.37,5.69-5.11a.45.45,0,0,1,.19-.11c2.34-.67,8.71-2.71,10.13-4.13s3.47-7.22,4.13-9.33a.38.38,0,0,1,.09-.15,23.64,23.64,0,0,0,2.56-4.13.93.93,0,0,0,0-.77,2,2,0,0,0-1-.77c-11.56,3-12.24,2.38-12.46,2.17a.61.61,0,0,1-.18-.56,8.87,8.87,0,0,1,1.54-2.61,11.39,11.39,0,0,0,1.12-1.73c.34-.84.55-2.85-.46-3.69-.08-.07-.12-.06-.13-.06-.44.08-1.17,1.43-1.66,2.32a15.8,15.8,0,0,1-1.14,1.91,20.83,20.83,0,0,1-2.75,2.65,12.55,12.55,0,0,0-2.65,2.69L209.2,164a.42.42,0,0,1-.07.13Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.573197893032c2025e58ae331b0108ad.svg";
export { ForwardRef as ReactComponent };